import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './PlanStatus.css';

const PlanStatus = ({ onNavigate }) => {
    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        try {
            const token = localStorage.getItem('token');
            let response = await fetch('/api/subscriptions/me', {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.status === 404) {
                console.log('[PlanStatus] /api/subscriptions 404, trying /api/billing...');
                response = await fetch('/api/billing/me', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            }

            const data = await response.json();
            setSubscription(data);
        } catch (err) {
            console.error('Failed to fetch subscription:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="plan-status-skeleton" />;

    const plan = subscription?.plan_id || 'starter';
    const planName = subscription?.plan_name || 'Starter';

    return (
        <div className={`plan-status-card plan-${plan}`}>
            <div className="plan-info">
                <span className="plan-label">Current Plan</span>
                <span className="plan-name">{planName}</span>
            </div>

            {plan === 'starter' && (
                <NavLink to="/app/pricing" className="btn-upgrade-sm" onClick={onNavigate}>
                    Upgrade
                </NavLink>
            )}

            <div className="plan-progress">
                <div className="progress-label">
                    <span>Templates Used</span>
                    <span>1 / {subscription?.features?.max_templates || 3}</span>
                </div>
                <div className="progress-bar">
                    <div className="progress-inner" style={{ width: '33%' }} />
                </div>
            </div>
        </div>
    );
};

export default PlanStatus;
